import {AxiosInstance} from 'axios'
import _Vue from 'vue'
import BanzaiOauth2Service from '@/services/banzai-oauth2.service'

export default {
  install(
    Vue: typeof _Vue,
    {http}: { http: AxiosInstance }) {
    Vue.prototype.$banzaiOauth2 = new BanzaiOauth2Service(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiOauth2: BanzaiOauth2Service;
  }
}
